import { aggregateSumFuncByField } from '../ClassificationTable/utils';

export const GQL_METHOD = 'unclassifiedTechSpends';
export const SORTING_TYPE = 'UnclassifiedTechSpendGroupSort';
export const FILTER_TYPE = 'UnclassifiedTechSpendGroupFilter';

export const PARENT_COLUMNS = {
  supplier: 'supplier',
  businessUnit: 'businessUnit',
  country: 'country',
  cost: 'cost',
  expenseType: 'expenseType',
  spendType: 'spendType',
};

export const CHILDREN_COLUMNS = {
  apSpendCategoryL1: 'apSpendCategoryL1',
  apSpendCategoryL2: 'apSpendCategoryL2',
  categoryL1Code: 'categoryL1Code',
  categoryL2Code: 'categoryL2Code',
  cost: 'cost',
  description: 'description',
  purchaseDate: 'purchaseDate',
  id: 'id',
};

export const GROUP_KEY = PARENT_COLUMNS.supplier;
export const GROUP_HEADER = 'Supplier';

export const COLUMN_DEFS = [
  {
    field: PARENT_COLUMNS.supplier,
    hide: true,
    lockVisible: true,
  },
  {
    field: PARENT_COLUMNS.businessUnit,
  },
  {
    field: PARENT_COLUMNS.country,
  },
  {
    field: CHILDREN_COLUMNS.cost,
    valueGetter: aggregateSumFuncByField(CHILDREN_COLUMNS.cost),
    filter: 'agNumberColumnFilter',
  },
  {
    headerName: 'Taxonomy',
    marryChildren: true,
    children: [
      {
        field: CHILDREN_COLUMNS.apSpendCategoryL1,
        cellClass: 'taxonomy-item',
        lockVisible: true,
      },
      {
        field: CHILDREN_COLUMNS.apSpendCategoryL2,
        cellClass: 'taxonomy-item',
        lockVisible: true,
      },
    ],
  },
  {
    field: PARENT_COLUMNS.expenseType,
  },
  {
    field: PARENT_COLUMNS.spendType,
  },
  {
    field: CHILDREN_COLUMNS.id,
    filter: 'agNumberColumnFilter',
  },
  {
    field: CHILDREN_COLUMNS.purchaseDate,
    filter: 'agDateColumnFilter',
  },
  {
    field: CHILDREN_COLUMNS.description,
  },
];

export const config = {
  gridConfig: {
    columnDefs: COLUMN_DEFS,
  },
  columnParams: {
    groupColumnKey: GROUP_KEY,
    groupHeader: GROUP_HEADER,
    parentColumns: PARENT_COLUMNS,
    childrenColumns: CHILDREN_COLUMNS,
    gqlMethod: GQL_METHOD,
    sortingType: SORTING_TYPE,
    filterType: FILTER_TYPE,
  },
};

export default config;
